'use client';

import React from 'react';
import { DefaultDropdown } from '@/components/ui/DefaultDropdown';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';
import { CLUB_OPTIONS } from '@/features/b2b/register/services/registrationService';

export const ClubMembershipSection = ({ formData, handleSelectChange, handleInputChange, errors }) => {
  return (
    <>
      <p className="text-[#373945] text-base font-medium mb-2">
        Are you a member of a club?
      </p>

      <div className="mb-6">
        <DefaultDropdown
          items={CLUB_OPTIONS}
          onItemSelect={(value) => {
            handleSelectChange('club')(value);
            if (value !== 'Other' && formData.clubOther !== '') {
              handleSelectChange('clubOther')('');
            }
          }}
          title={formData.club || 'Select club'}
          maxHeight="max-h-[30rem]"
          errorClass={errors.club ? 'border-2 border-[#D32F2F]' : ''}
        />
      </div>

      {formData.club === 'Other' && (
        <RegFormField
          label='If "Other" Enter Here'
          name="clubOther"
          value={formData.clubOther}
          onChange={handleInputChange}
          required={formData.club === 'Other'}
          error={errors.clubOther}
          className="mb-12"
        />
      )}
    </>
  );
};
